import { PRIMITIVE_TYPES_INTEGER } from '#layers/data-model/constants/schema/primitive-type';
import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'identifier',
	name: '$t:field_types.identifier.name',
	description: '$t:field_types.identifier.description',
	icon: 'lucide:key',
	sort: 800,
	keywords: ['uuid', 'key', 'primary key', 'id', 'auto increment'],
	supportedPrimitiveTypes: ['uuid', 'string', ...PRIMITIVE_TYPES_INTEGER],
});
